document.addEventListener('alpine:init', () => {
  Alpine.data('video', () => ({
    isPlaying: false,
    fastTabsHandler: null,

    init() {
      this.fastTabsHandler = () => {
        if (this.isPlaying) {
          this.pause();
        }
      };

      window.addEventListener('fast-tabs', this.fastTabsHandler);
    },

    destroy() {
      if (this.fastTabsHandler) {
        window.removeEventListener('fast-tabs', this.fastTabsHandler);
      }
    },

    play(muted = 0) {
      this.$root.classList.add('video--played');

      const match = this.$refs.iframe.dataset.vimeoId.match(/([0-9]+)(?:\/([0-9a-z]+)|$)?/i);

      if (!match) {
        return;
      }

      const m1 = match[1];
      const m2 = match[2] ? `h=${match[2]}&` : '';

      this.$refs.iframe.src = `https://player.vimeo.com/video/${m1}?${m2}autoplay=1&title=0&byline=0&portrait=0&muted=${muted}&api=1`;
      this.isPlaying = true;
    },

    pause() {
      if (!this.$refs.iframe?.contentWindow) {
        return;
      }

      this.$refs.iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), 'https://player.vimeo.com');

      this.isPlaying = false;
    },
  }));
});